import React, { useMemo, useState } from 'react';
import {
  IChannelLanguagePerformance,
  IRealtimeCommunityType,
  IRealtimeOpinionsTabType,
  IRealtimeOrganizationType,
} from '../../type';
import { FilterFixed, useFilterDataHook } from '@op/components/FilterCommon';
import { DBO_TM } from '@op/utils/format';
import CardCommon from '@op/components/CardCommon';
import ChannelLanguageChart from '../../component/ChannelLanguageChart';
import {
  METRICS_LIST,
  REALTIME_CHANNEL_ACCOUNT_OPTIONS,
  REALTIME_CHANNEL_TYPE_OPTIONS,
  REALTIME_TAB_OPTIONS,
} from '../../constant';
import { reviewsFormat } from '@op/utils/value';
import { Segment } from 'tea-component';
import useLanguage from '@op/hooks/useLanguage';
import { getSegmentWithIcon } from '../../utils';
import { useRealtimeRefresh } from '../../hook';
import { AppContext } from '../KeyMetricsOverview/context';

const ChannelPerformance = (props: IChannelLanguagePerformance) => {
  const { gameInfo } = props;

  const { formatMessage, formatOptionsMessage } = useLanguage();
  const [organization, setOrganization] =
    useState<IRealtimeOrganizationType>('all');
  const [reviewTypes, setReviewTypes] =
    useState<IRealtimeCommunityType>('total');
  const [deadline, setDeadline] = useState<IRealtimeOpinionsTabType>('current');
  const {
    scrollBody,
    loading: filterLoading,
    filter,
    changeFilter,
    filterOptions,
    confirmRef,
  } = useFilterDataHook({
    gameInfo,
    pageName: 'Key_Metrics',
  });

  const isToday = useMemo(
    () => (filterLoading ? false : DBO_TM.isToday(filter)),
    [filter, filterLoading],
  );
  const metricsList = useMemo(() => {
    if (reviewTypes === 'stream') {
      return METRICS_LIST.stream;
    }
    return METRICS_LIST.channel;
  }, [reviewTypes]);
  const { refresh, setRefresh, resetInterval, refreshTime, setRefreshTime } =
    useRealtimeRefresh(isToday);

  return (
    <>
      <FilterFixed
        scrollBody={scrollBody}
        filter={filterOptions}
        confirmRef={confirmRef}
        defaultValue={DBO_TM.utcFilterRangeDay(0, 0)}
        confirm={(value: any) => {
          changeFilter({ ...value, ...gameInfo });
          resetInterval();
        }}
        defaultConfig={{
          date: {
            isSingleDay: true,
          },
        }}
      ></FilterFixed>
      <CardCommon
        className="dbo-realtime-channel-language-performance dbo-realtime-channel-language-performance--channel-performance"
        contentCard
        title={
          <div className="dbo-realtime-channel-language-performance-segment-tab">
            <Segment
              className="segment-light segment-font12"
              value={reviewTypes}
              onChange={(value: string) => {
                setReviewTypes(value);
              }}
              options={getSegmentWithIcon(
                REALTIME_CHANNEL_TYPE_OPTIONS,
                formatMessage,
              )}
            />
            {reviewTypes !== 'stream' && (
              <Segment
                className="segment-light segment-font12"
                value={organization}
                onChange={(value: string) => {
                  setOrganization(value);
                }}
                options={formatOptionsMessage(REALTIME_CHANNEL_ACCOUNT_OPTIONS)}
              />
            )}
            {isToday && (
              <Segment
                className="segment-light segment-font12"
                value={deadline}
                onChange={(value: IRealtimeOpinionsTabType) => {
                  setDeadline(value);
                }}
                options={formatOptionsMessage(REALTIME_TAB_OPTIONS, undefined, {
                  placement: 'top',
                  style: { maxWidth: 220 },
                })}
              />
            )}
          </div>
        }
        loading={filterLoading}
        loadingHeight={1000}
      >
        <AppContext.Provider
          value={{ refresh, setRefresh, refreshTime, setRefreshTime }}
        >
          {metricsList.map((val: any, index: number) => {
            const {
              title,
              value,
              format = reviewsFormat,
              isPercent,
              isAvg,
            } = val;
            return (
              <>
                <ChannelLanguageChart
                  gameInfo={gameInfo}
                  title={title}
                  key={index + title}
                  metrics={value}
                  formatValue={format}
                  isPercent={isPercent}
                  isAvg={isAvg}
                  type={'channel'}
                  filter={filter}
                  reviewTypes={reviewTypes}
                  organization={organization}
                  deadline={deadline}
                />
              </>
            );
          })}
        </AppContext.Provider>
      </CardCommon>
    </>
  );
};

export default ChannelPerformance;
